import React from 'react';
import { Box } from '@mui/material';
import { ink } from '../../theme/tokens';

/**
 * Observation severities (`info | signal | warning | error`). Signal is blue to
 * match the Observation label; info is grey so the others stand out.
 */
export const SEVERITY_COLOURS: Record<string, string> = {
    error: '#F87171',
    warning: '#FBBF24',
    signal: '#60A5FA',
    info: '#64748B',
};

export const severityColour = (severity: string): string => SEVERITY_COLOURS[severity.toLowerCase()] ?? '#64748B';

/** `warning`, or `warning ×4` when counting. Styled with sx: it renders in portalled drawers too. */
const SeverityChip: React.FC<{ severity: string; count?: number }> = ({ severity, count }) => (
    <Box
        component="span"
        sx={{
            display: 'inline-flex', alignItems: 'center', gap: 0.5, fontSize: '0.625rem', fontWeight: 600,
            textTransform: 'uppercase', letterSpacing: '0.05em', color: ink(severityColour(severity)),
            border: `1px solid ${severityColour(severity)}55`, borderRadius: '4px', px: 0.75, py: 0.125, whiteSpace: 'nowrap',
        }}
    >
        {severity}{count !== undefined && <Box component="span" sx={{ opacity: 0.75 }}>×{count}</Box>}
    </Box>
);

export default SeverityChip;
